import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { RootState } from "../store";
import { decodeTokenBrandSlug } from "../services/api";

/**
 * Route guard for superadmin-only pages.
 *
 * SUPERADMIN = empty/falsy brand_slug in the JWT. A WL admin (non-empty
 * brand_slug) is redirected to the dashboard. Assumes ProtectedRoute has
 * already ensured the user is authenticated.
 */
const SuperAdminRoute: React.FC = () => {
  const token = useSelector((state: RootState) => state.auth.token) ?? localStorage.getItem("auth_token");
  const brandSlug = token ? decodeTokenBrandSlug(token) : null;

  if (brandSlug) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default SuperAdminRoute;
